import {
    Box, Typography,
} from '@material-ui/core'
import React from 'react'
import classes from './VoiceServiceCheckoutWarning.styles'

export default function VoiceServiceBottomMessage() {
    return (
    <Box className={classes.chatSection}>
        <Typography variant="body1" className={classes.chatTitle}>
        <strong>Let's chat!</strong>
        </Typography>
        <Typography variant="body1" className={classes.chatText}>
        In order for us to assess your needs and make sure we are offering you the right services, please call our sales team on{' '}
        <a href="tel:08081750509">0808 175 0509</a> from 9am - 8pm Monday to Friday and from 9am – 5pm on Saturday.
        </Typography>
    </Box>
)
}
